export default class Project {
    constructor(names,descriptions,client,image,services) {
        this.names = names;
        this.descriptions = descriptions;
        this.client = client;
        this.image = image;
        this.services = services;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.names)) { if(!value) { result = false; break; } }
        for (const [key, value] of Object.entries(this.descriptions)) { if(!value) { result = false; break; } }

        if(result) result = this.client && this.image && this.services && this.services.length;

        return result;
    }
}